<template>

  <form class="form-inline form-multiselect">
    <label>Tagged with</label>
    <div class="multiselect-control">
      <multiselect
        v-model="selected"
        track-by="name"
        :options="options"
        :multiple="true"
        :custom-label="tagLabelFormatter"
        :showLabels="false"
        :closeOnSelect="false"
        :disabled="!options.length"
        :placeholder="options.length ? 'Choose tag' : 'No tags available'">
      </multiselect>
    </div>
  </form>

</template>

<script>
  import Multiselect from 'vue-multiselect'
  import api from '../../api'

  export default {
    name: 'TagsSearch',
    components: {Multiselect},
    data () {
      return {
        options: [],
        selected: []
      }
    },
    methods: {
      refresh () {
        api.authenticatedRequest('get', '/tags')
          .then(response => {
            this.options = response.data.data
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      tagLabelFormatter (option) {
        return option.name
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.refresh()
      })
    }
  }
</script>

<style>
  .form-inline.form-multiselect {
    display: flex;
    align-items: center;
  }

  .multiselect-control {
    padding: 0 12px;
  }

  .multiselect > .multiselect__tags {
    min-height: 30px;
    padding-top: 4px;
    border-color: #d2d6de;
  }
</style>



// WEBPACK FOOTER //
// TagsSearch.vue?77f34d61